import { render, staticRenderFns } from "./StockMovements.vue?vue&type=template&id=792b3ff1&scoped=true&"
import script from "./StockMovements.vue?vue&type=script&lang=js&"
export * from "./StockMovements.vue?vue&type=script&lang=js&"
import style0 from "./StockMovements.vue?vue&type=style&index=0&id=792b3ff1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792b3ff1",
  null
  
)

export default component.exports